import { getSendToAnalyticsOnce } from '@sber-site/business-kit/src/analytics/getSendToAnalyticsOnce';

import getSendToAnalytics from './getSendToAnalytics';

export const sendToAnalytics = getSendToAnalytics('StratchingCards');
export const sendToAnalyticsOnce = getSendToAnalyticsOnce('StratchingCards');

export const pushRetentionShow = (isShownWidget, eventLabelWithType) => {
    if (isShownWidget) {
        sendToAnalytics('retention_show', eventLabelWithType);
    }
};

export const pushRetentionShowButton = (textButton, linkButton) => {
    if (!!textButton && !!linkButton) {
        sendToAnalytics('retention_show_button', textButton);
    }
};

export const pushRetentionEmpty = (textFromServiceVar, variableForText, eventLabelWithType) => {
    if (
        Object.prototype.hasOwnProperty.call(textFromServiceVar, variableForText) &&
        textFromServiceVar[variableForText].length === 0
    ) {
        sendToAnalytics('retention_empty', eventLabelWithType);
    }
};
